<div class="modal-header">
    <h4 class="modal-title">Invalid Quantity Increment</h4>
</div>
<div class="modal-body">
    <div class="modal-body-inner">
        <div class="add-user-form">
            <p class="warning-message">
                The entered quantity of <strong>{{ quantity }} {{ uom }}</strong> does not align with this product's
                Minimum Order Increment (MOI) of <strong>{{ moi }} {{ uom }}</strong>. Allocating a non-compliant
                quantity may result in fulfilment discrepancies. Do you want to proceed anyway?
            </p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="dark-bordered-btn dont-send-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="submit-btn-grey status-modal-save" (click)="confirm()">Submit</button>
</div>
